<template>
    <section>
        <div class="titulo">
            <div class="margem container">
                <h2>Relatório por Categoria</h2>
            </div>
        </div>
        <div class="margem container">
            <div class="bloco margem">
                <fieldset class="grid-4 " style="margin: 0 0 1rem 0;">
                    <div>
                        <label>Ano / Exercício: </label>
                        <select v-model="anoSelecionado">
                            <option value="" disabled>Selecione</option>
                            <option v-for="item in anos" :key="item.ano" :value="item.ano">{{ item.ano }}</option>
                        </select>
                    </div>
                    <div>
                        <label>Grupo de Contas: </label>
                        <select v-model="selectedGrupo" @change="updateSubgrupos">
                            <option value="" disabled>Selecione</option>
                            <option v-for="grupo in grupos" :key="grupo.id" :value="grupo">{{ grupo.descricaoDRE }}
                            </option>
                        </select>
                    </div>
                    <div>
                        <label>Subgrupo: </label>
                        <select v-model="selectedSubgrupo" @change="updateCategorias">
                            <option value="" disabled>Selecione</option>
                            <option v-for="subgrupo in subgrupos" :key="subgrupo.id" :value="subgrupo"> {{
                                subgrupo.descricaoDRE }} </option>
                        </select>
                    </div>
                    <div>
                        <label>Categoria: </label>
                        <select v-model="selectedCategoria">
                            <option value="" disabled>Selecione</option>
                            <option v-for="categoria in categorias" :key="categoria.id" :value="categoria"> {{
                                categoria.descricao }} </option>
                        </select>
                    </div>
                </fieldset>
                <div class="alinha-centro ">
                    <button class="acao-secundaria botao-pequeno " @click="limparFiltros">Limpar</button>
                </div>
            </div>
            <div class="bloco margem">
                <div class="table-container">
                    <table class="tabela">
                        <thead>
                            <tr>
                                <th class="header">Categoria</th>
                                <th class="header"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(grupo, gIndex) in gruposFiltrados" :key="gIndex">
                                <tr class="grupo-row">
                                    <td colspan="2" style="font-size:0.9rem;">
                                        <strong>{{ grupo.descricaoDRE }}</strong>
                                    </td>
                                </tr>
                                <template v-for="(sub, sIndex) in grupo.subgrupo" :key="`${gIndex}-${sIndex}`">
                                    <tr class="subgrupo-row" @click="toggle(sub.id)" style="cursor:pointer;">
                                        <td colspan="2">
                                            <i style="font-size:1em;" v-if="!abertos.has(sub.id)"
                                                class="fa-regular fa-square-caret-right"></i>
                                            <i style="font-size:1em;" v-else
                                                class="fa-regular fa-square-caret-down"></i> &nbsp; <span>{{
                                                    sub.codigoDRE }} - {{ sub.descricaoDRE }}</span>
                                        </td>
                                    </tr>
                                    <template v-if="abertos.has(sub.id)">
                                        <template v-if="sub.categoriaDRE && sub.categoriaDRE.length">
                                            <template v-for="(cat, cIndex) in sub.categoriaDRE"
                                                :key="`${sIndex}-${cIndex}`">
                                                <tr>
                                                    <td><strong>{{ cat.descricao }}</strong></td>
                                                    <td></td>
                                                </tr>
                                                <template
                                                    v-if="cat.grupos && cat.grupos['Executor'] && cat.grupos['Executor'].length">
                                                    <tr v-for="exec in cat.grupos['Executor']"
                                                        :key="`${cat.id}-${exec.id}`" class="executor-row">
                                                        <td> {{ exec.nome }} </td>
                                                        <td class="valores-duplos">
                                                            <div class="valor-previsto">Valor Previsto: <span>R$
                                                                    0,00</span></div>
                                                            <div class="valor-realizado">Valor Realizado: <span>R$
                                                                    0,00</span></div>
                                                        </td>
                                                        <!-- <money3 v-bind="config"
                                                            style="font-size: smaller; color: var(--cor-sucesso); border: 1px solid var(--cor-separador); border-radius: 6px;">
                                                        </money3> -->
                                                    </tr>
                                                </template>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import anoexercicioService from '@/services/ano-exercicio-service'
import estruturaService from '@/services/estrutura-service'
// import { Money3Component } from 'v-money3';


export default {
    name: 'RelatorioOrcamentosView',
    components: {
        // money3: Money3Component,

    },
    data() {
        const currentYear = new Date().getFullYear()
        return {
            config: {
                masked: false,
                prefix: 'R$ ',
                thousands: '.',
                decimal: ',',
                precision: 2,
            },
            anos: [],
            anoSelecionado: currentYear,
            grupos: [],
            subgrupos: [],
            categorias: [],
            selectedGrupo: null,
            selectedSubgrupo: null,
            selectedCategoria: null,
            abertos: new Set(),
        }
    },

    computed: {
        gruposFiltrados() {
            let filtrados = this.grupos

            if (this.selectedGrupo) {
                filtrados = filtrados.filter(g => g.id === this.selectedGrupo.id)
            }

            if (this.selectedSubgrupo) {
                filtrados = filtrados.map(g => ({
                    ...g,
                    subgrupo: g.subgrupo.filter(s => s.id === this.selectedSubgrupo.id),
                }))
            }

            if (this.selectedCategoria) {
                filtrados = filtrados.map(g => ({
                    ...g,
                    subgrupo: g.subgrupo.map(s => ({
                        ...s,
                        categoriaDRE: s.categoriaDRE.filter(c => c.id === this.selectedCategoria.id),
                    })),
                }))
            }

            return filtrados
        },
    },

    methods: {
        async obterAnos() {
            try {
                const response = await anoexercicioService.obterAnoExercicio()
                this.anos = response.data
            } catch (error) {
                console.error('Erro ao obter anos:', error)
            }
        },

        async obterEstrutura() {
            try {
                const response = await estruturaService.obterEstrutura()
                this.grupos = Array.isArray(response.data) ? response.data : []
                this.abertos = new Set()
            } catch (error) {
                console.error('Erro ao obter estrutura:', error)
            }
        },

        updateSubgrupos() {
            this.subgrupos = this.selectedGrupo?.subgrupo ?? []
            this.selectedSubgrupo = null
            this.selectedCategoria = null
            this.categorias = []
        },

        updateCategorias() {
            if (!this.selectedSubgrupo) {
                this.updateSubgrupos()
                return
            }
            this.categorias = this.selectedSubgrupo.categoriaDRE ?? []
            this.selectedCategoria = null
        },

        limparFiltros() {
            this.selectedGrupo = null
            this.selectedSubgrupo = null
            this.selectedCategoria = null
            this.subgrupos = []
            this.categorias = []
        },

        toggle(id) {
            if (this.abertos.has(id)) this.abertos.delete(id)
            else this.abertos.add(id)
        },


    },

    mounted() {
        this.obterAnos()
        this.obterEstrutura()
    },
}
</script>
<style scoped>
.table-container {
    overflow-x: auto;
}

.executor-row td {
    font-size: 1em;
    padding-left: 20px;
}

.botao-pequeno {
    font-size: 0.8rem;
    padding: 4px 25px;
    height: 28px;
    width: auto;
    border-radius: 6px;
    background-color: var(--cor-bg);
    cursor: pointer;
    transition: all 0.2s ease;
}

.header {
    position: sticky !important;
    top: 0 !important;
    z-index: 999 !important;
    background-color: var(--cor-bg) !important;
    font-size: 1rem;

}

.valores-duplos {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    line-height: 1.2;
}

.valor-previsto {
    font-size: 0.85rem;
    color: var(--cor-sucesso);
}

.valor-realizado {
    font-size: 0.85rem;
    color: var(--cor-erro);
}
</style>
